import axios from 'axios';
import { Message } from 'element-ui';

axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8';
// 创建axios实例
const service = axios.create({
  // axios中请求配置有baseURL选项，表示请求URL公共部分
  baseURL: process.env.VUE_APP_BASE_API,
  // 超时
  timeout: 60000,
  withCredentials: true,
  headers: {
    'x-okapi-tenant': 'pkulib',
  }
});

// request拦截器
service.interceptors.request.use((config) => {
  if (sessionStorage.getItem('token')) {
    config.headers.token = sessionStorage.getItem('token');
  }
  return config;
},
  (error) => {
    console.log(error);
    Promise.reject(error);
});

// 响应拦截器
service.interceptors.response.use((res) => {
    return res.data;
  },
  (error) => {
    if(error.response.status !== 422){
      Message({
        message: '网络错误',
        type: 'error',
        duration: 5 * 1000,
      });
    }
    return Promise.reject(error);
  }
);

export default service;
